<template>
  <div id="app">
        
    <div v-if="showModal" id='modal-container' @keyup.esc="showModal = false" tabindex="0">
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-dialog d-flex flex-column align-content-center" role="document">
                        <div class="modal-content"  style='z-index: 10'>
                            
                            <div class="modal-header">
                                <div class="col-01" ><button class="bt-help" @click="btHelp()"><i class="icon-help ti-help-alt"></i></button> <h5 class="modal-title">{{ title }}</h5></div>
                                <div class="col-02" v-if='export_csv != false'>
                                  <button type="button" class="csv-bt" aria-label="CSV" @click="btCSV()">
                                    <span class='ti-file'> CSV</span>
                                  </button>
                                </div>
                                <!-- <div class="col-03" > -->
                                <div class="col-12" >
                                  <button type="button" id='close-button' class="close" data-dismiss="modal" aria-label="Close" @click="showModal = false" ref="closer">
                                    <!-- <span aria-hidden="true">&times;</span> -->
                                    <span class='ti-close'></span>
                                  </button>
                                </div>
                                <!-- <input id='search-input' name="query" v-model="filterKey" placeholder='type here'> -->
                            </div>
                            
                            <div class="modal-body overflow-auto" style='width: 100%;'>

                                <table class='table' v-if='data.length != 0'>
                                    <thead>
                                        <tr>
                                            <th v-for="(value, key) in columns" :key='key'>
                                                <div v-if="key != 'link' && key != 'link_rci' && key != 'id_planta'">
                                                    <p class='table-header' @click="key != 'rdps' && key != 'approved_datetime' ? sortBy(value[1] || key) : null" :class="key != 'rdps' ? 'cursor-pointer': ''">
                                                        {{ value[0] | capitalize }}
                                                        <span class="arrow" v-if="(sortKey == key || sortKey == value[1]) && key != 'rdps'" :class="(sortKey == key || sortKey == value[1]) ? order: ''"></span>
                                                    </p>
                                                    <br>
                                                    <input v-if="key != 'rows'" :disabled="(key == 'rdps' || key == 'status' || key == 'approved_datetime')" type="text" class='table-input' @keyup.enter="filterGrid()" v-model="sortFilters[value[1] || key]">
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                    <tr v-for="entry in filteredData">
                                        <td v-for="(value, key) in columns" :key='key'>
                                        <div v-if="key == 'report_number' && entry[key]">
                                            <div class="href" @click="changeModal({'link_rdp': entry['link'], 'link_rci': entry['link_rci']})">{{ entry[key] | handleNull }}</div>
                                        </div>
                                        <div v-else-if="key == 'status' && entry[key]">
                                           <div :class="'icon-status-'+entry[key]"></div>
                                        </div>
                                        <!-- ABRIR A FOTO -->
                                        <div v-else-if="key == 'serie' && entry[key]">  
                                            <div v-if="entry['id_planta'] == null">
                                              <div class="href" @click="changeModalPhoto({'link_photo': 'https://s3-sa-east-1.amazonaws.com/semeq-repo/img/'+planta+'/sensor/'+entry[key]+'.jpg', 'sensor_photo': entry[key] })">{{ entry[key] | handleNull }}</div><br>
                                            </div>
                                            <div v-if="entry['id_planta'] != null">
                                              <div class="href" @click="changeModalPhoto({'link_photo': 'https://s3-sa-east-1.amazonaws.com/semeq-repo/img/'+entry['id_planta']+'/sensor/'+entry[key]+'.jpg', 'sensor_photo': entry[key] })">{{ entry[key] | handleNull }}</div><br>
                                            </div>
                                        </div>
 
                                        <!-- ABRIR A RDPS -->
                                        <div v-else-if="key == 'rdps' && entry[key]">
                                           <div v-for="(v, k) in entry[key]" :key='k'>
                                              <!--<a :href="entry[key][k].link" >{{entry[key][k].number}}</a><br>-->
                                               <div class="href" @click="changeModal({'link_rdp': http_to_https(entry[key][k].link)+'&lang=EN', 'link_rci': entry[key][k].rdp, 'id_rdp': entry[key][k].rdp, 'technique_id': '2' , 'report_number': entry[key][k].number , 'plant': entry['planta'] , 'area': entry['area'] })">{{ entry[key][k].number | handleNull }} </div><br>
                                           </div>
                                        </div>

                                        <div v-else-if="key == 'approved_datetime' && entry['rdps']">
                                            <div v-for="(v, k) in entry['rdps']" :key='"approved_datetime" + k'>
                                                {{ entry['rdps'][k].approved_datetime | handleNull }}
                                            </div>
                                        </div>

                                        <div v-else-if="((key != 'link') && (key != 'link_rci') && (key != 'id_planta'))">
                                            {{entry[key] | handleNull }}
                                        </div>

                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                
                                <div id='spinner-loading' class="d-flex justify-content-center align-content-middle" v-if='data.length == 0'>
                                     <div class="loader"></div> 
                                </div>
                            </div>

                           <!-- <div class="modal-footer">
                                <ul class="pagination">
                                    <li class="page-item"><button class=" btn page-link" @click='pg--' :disabled='pg==0 || data.length==0'>Previous</button></li>
                                    <li class="page-item"><button class="btn page-link" @click='pg++' :disabled='data.length < 30'>Next</button></li>
                                </ul>
                            </div>-->

                        </div>

                    </div>
                </div>
            </div>
        </transition>
    </div>

    <!-- MODAL AVISO GERANDO ARQUIVO-->
    <div v-if="showModalFile" id='modal-container' @keyup.esc="showModalFile = false" tabindex="1" >
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-alert modal-dialog d-flex flex-column align-content-center" role="document" >
                        <div class="modal-content"  style='z-index: 10'>
                            
                            <div class="modal-header">
                                &nbsp;                                
                            </div>
                            
                            <div class="modal-body overflow-auto" style='color: #eee; font-weight: bold; height: 47px;
padding: 5px 0px;'>
                                <div class="loader loader-div"></div> 
                                <div class="txt-loader"> {{ $t("160") }}</div>
                            </div>

                            <div class="modal-footer">
                                &nbsp;
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </transition>
    </div>
    <!-- FIM MODAL AVISO GERANDO ARQUIVO-->
     <!-- MODAL HELP-->
    <div v-if="showModalHelp" id='modal-container' @keyup.esc="showModalHelp = false" tabindex="1" >
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-alert modal-dialog d-flex flex-column align-content-center" role="document" >
                        <div class="modal-content"  style='z-index: 10'>
                            
                            <div class="modal-header header-help">
                                <div class="col-01" ><i class="icon-help ti-help-alt"></i> <span class="modal-title-help">{{ titleHelp }}</span> 
                                </div>
                                <div class="col-02" >
                                    &nbsp;
                                </div>
                                <div class="col-03" >
                                    <button type="button" id='close-button' class="close-help" data-dismiss="modal" aria-label="Close" @click="showModalHelp = false" ref="closer"><span class='ti-close'></span>
                                    </button>

                                </div>                                 
                            </div>
                            
                            <div class="modal-body overflow-auto body-help">
                                {{ txtHelp }}
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
    <!-- FIM MODAL HELP-->

  </div>
</template>

<script>
/* eslint-disable */

import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex';
import mixin from '../../../../utils/mixin'

export default {
    data() {
        return {
            data: [],
            pg: 0,
            showModal: false,
            showModalFile: false,
            showModalHelp: false,
            title: '',
            columns: {},
            url: '',
            sortFilters: {},
            sortOrders: {},
            order: 'asc',
            sortKey: '',
            export_csv: true,
            titleHelp: '',
            txtHelp: '',
        }
    },
    mixins: [mixin],
    computed: {
        filteredData: function () {
            return this.data;
        },
        gridInfo: function () {
            return this.gridOnline();
        },
        planta: function(){
          return this.filtersOn().planta;
        }
    },
    filters: {
        capitalize: function (str) {
            return str.charAt(0).toUpperCase() + str.slice(1)
        },
        handleNull: function (str){
            str = str == 0 ? str.toString() : str;
            return str || '-';
        },
    },
    methods: {
        getData: function (pg){
            const API = process.env.ROOT_API

            this.data = [];

            let self = this;
            axios({method: 'GET', url: API + this.url + '&sort=' + this.sortKey + '&order=' + this.order, params: this.sortFilters, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
                .then(function({ data }){
                    if (data.result.length > 0){
                        self.data = data.result;
                    } else {
                        self.data = [{'-': '-'}];
                    } 
                    self.pg = pg;
                })
                .catch(function(error){
                    // from mixin
                    self.ApiErrorHandler(self, error.response.data.status_code);
                })
        },
        filterGrid: function () {
            this.getData(0)
        },
        sortBy: function (key) {
            if (this.sortKey != key) { this.order = 'asc' }
            else { this.order = this.order == 'desc' ? 'asc' : 'desc' }

            this.sortKey = key
            this.getData(0)
        },
        btHelp: function (){
          this.showModalHelp = true
        },
        btCSV: function (){        
          let self = this;
          self.showModalFile = true
          const API = process.env.ROOT_API
          let name_chart_file = this.name_chart
          var file = 'csv'
          axios({
            method: 'GET', 
            url: API + this.url + '&file=' + file + '&sort=' + this.sortKey + '&order=' + this.order, 
            params: this.sortFilters,
            responseType: 'blob',
            headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` 
          }})
          .then(function({ data }){ 
              const url = window.URL.createObjectURL(new Blob([data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', name_chart_file+'.csv');
              document.body.appendChild(link);
              link.click();
              self.showModalFile = false
          })
          .catch(function(error){
              // from mixin
              self.ApiErrorHandler(self, error.response.data.status_code);
          })   
          
        },
        http_to_https: function (url) {
            return 'https://' + url.split('://')[1]
        },
        ...mapGetters(['gridOnline', 'filtersOn']),
        ...mapMutations(['changeModal', 'changeModalPhoto']),
    },
    watch: {
        show: function(newValue){
            this.showModal = newValue;
        },
        url: function(newValue){
            this.url = newValue;
            this.sortFilters = {};
            this.sortKey = '';
            this.order = 'asc';
            this.getData(0);
        },
        pg: function(newValue){
            if (newValue >= 0){
                this.getData(newValue);
            }
        },
        gridInfo: function (newValue){
            this.title = newValue.title.toUpperCase();
            this.url = newValue.url;
            this.name_chart = newValue.name_chart;
            this.columns = newValue.columns;
            this.showModal = newValue.show;
            this.export_csv = newValue.export_csv;
            this.titleHelp = newValue.titleHelp;
            this.txtHelp = newValue.txtHelp;

            this.$nextTick(function () {
                this.$refs.closer.focus()
            })
        }
    },
}

</script>

<style scoped>

body {
  font-family: Helvetica Neue, Arial, sans-serif;
  font-size: 14px;
  color: #444;
}

.table {
    border-radius: 0px; 
    width: 100%;
    margin: 0;
    height: 100%;
} 

th {
    background-color: #343a40;
    color: white;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 12px;
    white-space: nowrap;
}

td {
  /* min-width: 120px; */
    padding: 10px 10px;
    white-space: nowrap;
    width: 1%;
    background-color: #343a40;
    color: white;
}

td{
    font-size: 11px;
}

tr:nth-child(even) > td {
  background-color: #454d55;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.desc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #fff;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #fff;
}

#search-input{
    position: absolute;
    right: 65px;
    top: 5px;
}

.modal-mask {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  width: 100vw;
}

.modal-header{
    height: 49px;
    align-items: center;
    align-content: center;
    color: white;
}

.modal-body{
    margin: 0;
    padding: 0;
    overflow: auto;
    max-height: 80vh;
}

.modal-dialog{
    width: 90vw;
}

.modal-content{
    padding: 0;
    /* background: #1f1f20; */
    background: #2a2a2e;
    /* max-height: 80vh; */
}

.table{
    max-height: 90vh;
}

.col-01{
    width: 80%;
    float: left;
}
.col-02{
    width: 15%;
    float: left;
}
.col-03{
    width: 5%;
    float: left;
}
.csv-bt{
    outline: none;
    z-index: 10;
    float: right;
    background: #343a40;
    border-color: #343a40;
    color:
    white;
    transition: background 0.4s;
    cursor: pointer;
    margin-top: -6px;
    height: 35px;
    border-radius: 5px;
}
.csv-bt:hover{
    background: #454d55;
}


#close-button{
    outline: none;
    z-index: 10;
    margin-right: 10;
}

.ti-close{
    color: white;
    border-color: white;
    text-shadow: white;
}

.modal-footer{
    height: 50px;
    justify-content: end;
    align-items: center;
    padding: 5px 15px;
    color: white;
}

.page-link{
    background: #343a40;
    border-color: #343a40;
    color: white;
    transition: background 0.4s;
    cursor: pointer;
    margin-top: -20px;
    height: 35px;
}
.page-link:hover{
    background: #454d55;
}

.modal-title{
    color: white;
    font-weight: 100;
    font-size: 22px;
    margin: -10px 1px;
}

.table td.fit, 
.table th.fit {
    white-space: nowrap;
    width: 1%;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}

#spinner-loading{
    padding: 50px 0;
}

.loader {
  border: 6px solid #f3f3f3; /* Light grey */
  border-top: 6px solid #72b5e1; /* Blue */
  border-radius: 50%;
  width: 35px;
  height: 35px;
  animation: spin 2s linear infinite;
  margin: 0 auto;
}
.loader-div{
    float: left;
    margin-left: 22%;
    margin-right: 5%;

}
.txt-loader{
    padding-top: 8px;
}
.modal-alert{
    width: 30% !important;
}
.icon-status-1{
  margin: 0px auto;
  border: 1px solid #90ed7d;
  border-radius: 28px;
  width: 12px;
  background:#90ed7d;
  height: 12px;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  transform: scale(1);
  animation: pulse 2s infinite;
}
.icon-status-2{
  margin: 0px auto;
  border: 1px solid #e4d354;
  border-radius: 28px;
  width: 12px;
  background:#e4d354;
  height: 12px;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  transform: scale(1);
  animation: pulse 2s infinite;
}
.icon-status-3{
  margin: 0px auto;
  border: 1px solid #f45b5b;
  border-radius: 28px;
  width: 12px;
  background:#f45b5b;
  height: 12px;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  transform: scale(1);
  animation: pulse 2s infinite;
}
.icon-status-4{
  margin: 0px auto;
  border: 1px solid #6b91c9;
  border-radius: 28px;
  width: 12px;
  background:#6b91c9;
  height: 12px;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  transform: scale(1);
  animation: pulse 2s infinite;
}

.modal-alert{
    width: 30% !important;
}
.bt-help{
    float: left;
    margin-top: -3px;
    margin-left: -10px;
}
.modal-title-help{
    font-weight: bold;
    font-size: 16px;
}
.close-help{
    background: no-repeat;
    border: none;
    margin-left: -10px;
}
.header-help{
    border: 1px solid #134F69;
    height: 35px;
    background-color: #627c88;
    font-weight: bold;
    padding: 5px 5px;
    color: #ccc;
}
.body-help{
    color: #eee; 
    height: auto; 
    padding: 5px 5px;
}

.href{
  color: #68B3C8;
  cursor: pointer;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media screen and (max-width: 770px) {
    .modal-dialog {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin: 0;
    }
    .modal-alert{
        width: 100% !important;
    }
}

.table-input{
    width: 100%;
    height: 25px;
    font-size: 14px;
    padding: auto auto;
}

.table-header{
    margin: 0 auto;
    padding: 0;
    margin-bottom: -20px;   
}

.cursor-pointer{
    cursor: pointer;
}

 @media screen and (max-width: 650px) {
    .modal-title{
      font-size: 14px;
      margin-top: -3px;
    }
    .modal-body{
        max-height: 60vh;
    }
 }

 @media screen and (max-width: 420px) {
  .col-01{
      width: 62%;
  }
  .col-02{
      width: 30%;
  }
  .col-03{
    width: 8%;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/ChartsOnline/GridOnline.vue